module.exports = __webpack_public_path__ + "img/page-09.7d97f0cf.jpg";